import { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'
import _ from 'lodash'
import CachedIcon from '@mui/icons-material/Cached'

import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import AddIcon from '@mui/icons-material/Add'
import LowPriorityIcon from '@mui/icons-material/LowPriority'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { makeStyles } from '@mui/styles'
import { Drawer, Autocomplete, TextField, Chip, Typography, Grid, Button } from '@mui/material'

import { constants, PICTURE_SIZE, UPLOAD_TYPE, IMAGE_TYPE } from '../../Constants/constants'
import { newPost } from '../../helper/baseFetch_v2'
import { setAppVersion, setAppVersionValue } from '../../actions/appVersionAction'
import { getString } from '../../helper/util'
// import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay'
import { EditCreateDisplayV2 } from '../../Component/EditCreateDisplay/EditCreateDisplayV2'
import { TempTextInput } from '../../Component/Input/TempTextInput'
import { TempAutoSelectInput } from '../../Component/Input/TempAutoSelectInput'
import CheckboxGroupInput from '../../Component/Input/CheckboxGroupInput'
import MUISelect from '../../Component/common/field/MUISelect'
import { TempCheckBox } from '../../Component/Input/TempCheckBox'
import { TempBtn } from '../../Component/Input/TempBtn'
import { UploadImage } from '../../Component/UploadImage/UploadImage'
import { RestaurantList } from '../Restaurant/RestaurantList'
import { GlobalDialog } from '../../Component/GlobalDialog'
import { validateForm } from '../../validations/appVersionValidation'

import { formFields } from './AppVersionFormFields'

import { DEVICE_TYPE } from './constants'
import variables from '../../styles/globalVariables.scss'

import '../../styles/features/merchant/merchantUser.scss'
import { set } from 'react-ga'
import ReleaseAccordionList from './components/ReleaseAccordionList'

const { blackColor } = variables

const normalTextStyle = makeStyles(() => ({
  label: {
    '& .MuiFormLabel-root': {
      color: `${blackColor}`,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: `${blackColor}`,
    },
    '& .MuiFormLabel-root.Mui-disabled': {
      color: 'rgba(18, 18, 18, 0.54)',
    },
  },
}))

const helperTextStyles = makeStyles((theme) => ({
  root: {
    color: 'red !important',
  },
}))

const LOCAL_CONSTANT = {
  PRIVILEGE_ATTRIBUTE: {
    SHOP: 'SHOP',
    GROUP: 'GROUP',
  },
  PRIVILEGE_RESTURLID: 'privilegeRestUrlId',
  PRIVILEGE_GROUP_CODE: 'privilegeGroupCode',
}

export const AppVersionCreate = ({
  currentEditUser,
  setCurrentEditUser,
  hideTab,
  hideBottomBtnList,
  hidePrivilegeRestUrlIdEditButton = false,
  embeddedInRestaurantClone,
}) => {
  const dispatch = useDispatch()
  const store = useStore()
  const history = useHistory()
  const helperTextStylesClasses = helperTextStyles()
  const normalTextStyleClasses = normalTextStyle()
  const [clear, setClear] = useState(false)
  const [previewSelectedList, setPreviewSelectedList] = useState([])
  const [restUrlIdList, setRestUrlIdList] = useState([])
  const [dialog, setDialog] = useState({
    open: false,
    dialogActions: [],
  })
  const resource = 'appVersionPage'
  const savedAppVersion = useSelector((state) => state.appVersion.ui.appVersion)
  // console.log('savedAppVersion', savedAppVersion)
  const lang = useSelector((state) => state.lang.ui.lang)
  const theme = useSelector((state) => state.theme.ui.theme)
  const [inputError, setInputError] = useState({})
  // const [, setErrorVersion] = useState(AppVersionValidation.getVersion())
  const id = currentEditUser ? savedAppVersion.id : savedAppVersion.appVersion + '_' + savedAppVersion.buildNumber

  const tabs = [
    {
      label: { resource: resource, key: 'info' },
      tabIndex: constants.MERCHANT_USER_EDIT_TAB.INFO,
    },
  ]

  // recalc fields whenever relevant props change (including inputError)
  const fields = useMemo(() => {
    return formFields({
      resource,
      savedAppVersion,
      inputError,
      helperTextStylesClasses,
      normalTextStyleClasses,
      theme,
      onChangeInput,
      handleSaveImage,
    })
  }, [
    resource,
    savedAppVersion,
    // important: include inputError so form rebuilds when it changes
    inputError,
    helperTextStylesClasses,
    normalTextStyleClasses,
    theme,
    onChangeInput,
    handleSaveImage,
  ])

  // For create page we reuse the same Release UI components which expect arrays
  const releaseList = [savedAppVersion]
  const fieldsByRelease = [fields]

  const renderField = (inputSetting, index) => {

    // full-width types
    const isFullWidth = [
      constants.TYPE.TITLE,
      // constants.TYPE.FUNCTION,
      // constants.TYPE.CUSTOM,
    ].includes(inputSetting.type)

    let fieldContent
    switch (inputSetting.type) {
      case constants.TYPE.SELECT:
        fieldContent = <TempAutoSelectInput inputSetting={inputSetting} handleChange={inputSetting.handleChange ?? onChangeInput} />
        break
      case constants.TYPE.CHECKBOX:
        fieldContent = (
          <TempCheckBox
            checkBoxSetting={{
              className: inputSetting.className,
              name: inputSetting.name,
              label: inputSetting.label,
              value: inputSetting.value,
            }}
            handleChange={handleCheckBoxChange}
          />
        )
        break
      case constants.TYPE.FUNCTION:
        fieldContent = inputSetting.value
        break
      case constants.TYPE.TITLE:
        fieldContent = (
          <Typography variant="subtitle2" className="sub-title" sx={{ mt: 1, mb: 0.5, width: '100%' }}>
            {getString(lang, inputSetting.value.resource, inputSetting.value.key, theme)}
          </Typography>
        )
        break
      case constants.TYPE.CUSTOM:
        fieldContent = inputSetting.customContent
        break
      default:
        fieldContent = <TempTextInput inputSetting={inputSetting} handleChange={inputSetting.handleChange ?? onChangeInput} />
    }

    return (
      <Grid
        item
        key={index}
        xs={12}
        sm={isFullWidth || inputSetting.fullWidth ? 12 : 6}
        md={isFullWidth || inputSetting.fullWidth ? 12 : inputSetting.md ?? 4}
        sx={inputSetting.isEndOfLine ? { flexBasis: '100%', maxWidth: '100%' } : {}}
      >
        {fieldContent}
      </Grid>
    )
  }

  // const content = [
  //   {
  //     tab: fields.map((inputSetting, index) => {
  //       let content
  //       switch (inputSetting.type) {
  //         case constants.TYPE.SELECT:
  //           content = <TempAutoSelectInput inputSetting={inputSetting} handleChange={onChangeInput} />
  //           break
  //         case constants.TYPE.CHECKBOX:
  //           content = (
  //             <span className="merchant-user-check-box-wrapper">
  //               <TempCheckBox
  //                 checkBoxSetting={{
  //                   className: inputSetting.className,
  //                   name: inputSetting.name,
  //                   label: inputSetting.label,
  //                   value: inputSetting.value,
  //                 }}
  //                 handleChange={handleCheckBoxChange}
  //               />
  //             </span>
  //           )
  //           break
  //         case constants.TYPE.FUNCTION:
  //           content = inputSetting.value
  //           break
  //         case constants.TYPE.TITLE:
  //           content = (
  //             <div className={`${inputSetting.className + ' sub-title'}`}>
  //               {getString(lang, inputSetting.value.resource, inputSetting.value.key, theme)}
  //             </div>
  //           )
  //           break
  //         case constants.TYPE.CUSTOM:
  //           content = inputSetting.customContent
  //           break
  //         default:
  //           content = <TempTextInput inputSetting={inputSetting} handleChange={onChangeInput} />
  //       }
  //       return (
  //         <div className="edit-display-wrapper" key={index}>
  //           {content}
  //           {inputSetting.isEndOfLine && <div></div>}
  //         </div>
  //       )
  //     }),
  //     btn: hideBottomBtnList ? false : true,
  //   },
  // ]

  const bottomBtns = [
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: 'save' },
      onClick: onClickSave,
      className: 'margin-left-16',
      icon: <SaveIcon />,
    },
    // {
    //   variant: constants.STYLE.VARIANT.CONTAINED,
    //   color: constants.STYLE.PRIMARY,
    //   label: { key: 'clear' },
    //   disabled: false,
    //   onClick: onClickClear,
    //   className: 'margin-left-16',
    //   icon: <ClearIcon />,
    // },
  ]

  const onClickBackToCreate = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    onClickClear()
  }
  const onClickBackToList = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    history.push('/' + constants.PATH.APPVERSION.APPVERSION)
  }

  function onChangeRelease(releaseIdx, nameOrPatch, value) {
    // releaseIdx ignored for create (single release)
    // Apply all patched fields in a single cloned object and dispatch once
    const newAppVersion = _.cloneDeep(savedAppVersion)
    if (typeof nameOrPatch === 'object') {
      const patch = nameOrPatch
      Object.keys(patch).forEach((key) => {
        newAppVersion[key] = patch[key]
      })
    } else {
      newAppVersion[nameOrPatch] = value
    }
    dispatch(setAppVersion(newAppVersion))
  }

  function onChangeInput(name, e) {
    const isNumberField = ['buildNumber'].includes(name)
    const value = isNumberField ? Math.round(e) : e

    if (currentEditUser) {
      const temp = _.cloneDeep(currentEditUser)
      temp[`${name}`] = value
      setCurrentEditUser(temp)
    }

    // const isNumberField = ['buildNumber'].includes(name)

    // const value = isNumberField ? Math.round(e) : e

    dispatch(setAppVersionValue(name, savedAppVersion, '', value))
  }

  function handleSaveImage(name, fileId) {
    dispatch(setAppVersionValue(name, savedAppVersion, '', fileId))
  }

  function handleCheckBoxChange(name, e) {
    let tempAppVersion = _.cloneDeep(savedAppVersion)
    let permission = tempAppVersion[name]
    if (!e) {
      permission['read'] = true
      permission['write'] = true
    } else {
      permission['read'] = false
      permission['write'] = false
    }
    dispatch(setAppVersionValue(name, savedAppVersion, '', permission))
  }

  async function onClickSave() {
    const { valid, errors } = await validateForm(savedAppVersion)
    if (valid) {
      const body = {
        appVersion: savedAppVersion.appVersion,
        releaseList: [
          {
            buildNumber: savedAppVersion.buildNumber,
            customCode: savedAppVersion.customCode ?? null,
            tagList: savedAppVersion.tagList ?? [],
            buildTarget: savedAppVersion.buildTarget ?? {},
            releaseNote: savedAppVersion.releaseNote ?? null,
            documentList: savedAppVersion.documentList ?? [],
            remarks: savedAppVersion.remarks ?? null,
            file: savedAppVersion.file ?? null,
          },
        ],
      }

      newPost({
        path: 'gulu-console/merchant/shop-app-release',
        body: body,
        successCallback: (payload) => {
          setDialog({
            open: true,
            onClose: onClickBackToCreate,
            dialogContentText: { key: 'createSuccess' },
            dialogActions: [
              // { label: { key: 'backCreate' }, onClick: onClickBackToCreate, icon: <ArrowBackIcon /> },
              { label: { key: 'backList' }, onClick: onClickBackToList, icon: <LowPriorityIcon /> },
            ],
          })
          setClear(true)
        },
        store: store
      })
      setInputError(errors || {})
    //   AppVersionValidation.resetErrorMessages()
    } else {
      setInputError(errors || {})
      // setErrorVersion(AppVersionValidation.getVersion())
    }
  }

  function onClickClear() {
    setClear(true)
  }

  useEffect(() => {
    // if (!currentEditUser && !embeddedInRestaurantClone) {
      dispatch(setAppVersion(constants.APP_VERSION_INPUT))
      setClear(false)
      // AppVersionValidation.resetErrorMessages()
      setInputError({})
    // }
  }, [clear === true]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {/* <EditCreateDisplay
        code={savedAppVersion?.customId ? savedAppVersion.customId : ''}
        resource={resource}
        tabs={hideTab ? false : tabs}
        content={content}
        onChangeInput={onChangeInput}
        bottomBtns={bottomBtns}
        display={savedAppVersion.customId ? 'edit' : 'create'}
      /> */}
      <EditCreateDisplayV2>
        <EditCreateDisplayV2.Header
          resource={resource}
          display={savedAppVersion.id ? 'edit' : 'create'}
          code={savedAppVersion?.id ?? ''}
        />

        <EditCreateDisplayV2.Body>
            {/* Use the release accordion list to surface release note + docs along with fields */}
            <ReleaseAccordionList
              releaseList={releaseList}
              fieldsByRelease={fieldsByRelease}
              inputError={[inputError]}
              hideBottomBtnList={true}
              lang={lang}
              theme={theme}
              resource={resource}
              renderField={renderField}
              onAddRelease={() => { /* noop on create page */ }}
              onRemoveRelease={() => { /* noop on create page */ }}
              onClickUpdateStatus={() => { /* noop on create page */ }}
              onChangeRelease={onChangeRelease}
              hideCreateButton={true}
              hideRemoveButton={true}
            />
        </EditCreateDisplayV2.Body>

        <EditCreateDisplayV2.Footer>
            <Button variant="contained" color="primary" startIcon={<SaveIcon />} onClick={onClickSave}>
              {getString(lang, '', 'save', theme)}
            </Button>
          </EditCreateDisplayV2.Footer>
      </EditCreateDisplayV2>
      {dialog && dialog.open && <GlobalDialog dialogInfo={dialog} />}
    </>
  )
}
